export const TITLE = {
  pending: 'Acesso para menores de 18 anos',
  submitted: 'Aguardando liberação',
}
